import { createSlice, current } from "@reduxjs/toolkit";
import { items } from "../data";
import { sampleSize } from "lodash";
import SLOT_STATUS from "constants/slot-status";

const initialState = {
  // All items
  items: items,
  // number of fails user can
  health: 5,

  // User's score
  score: 0,

  timeFinished: false,

  // Slots to display
  slots: [],
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setItems: (state, action) => {
      const items = action.payload;
      const randomItems = sampleSize(items, 8);

      state.items = items;
      state.slots = randomItems.map((item) => [
        {
          ...item,
          status: SLOT_STATUS.ACTIVE,
        },
      ]);
    },

    displayRandomItem: (state, action) => {
      const items = state.items.filter(
        (item) => !state.slots.flat().some((i) => item.imageId == i.imageId)
      );
      const slotIndex = action.payload;
      const randomIndex = Math.floor(Math.random() * items.length);
      const randomItem = items[randomIndex];
      state.slots[slotIndex].push({
        ...randomItem,
        status: SLOT_STATUS.ACTIVE,
      });
    },

    submitCode: (state, action) => {
      const { index, code } = action.payload;
      const slotHistory = state.slots[index];
      const slot = slotHistory[slotHistory.length - 1];
      if (slot.code == code) {
        slot.status = SLOT_STATUS.SUCCESS;
        state.score += 1;
      } else {
        slot.status = SLOT_STATUS.FAIL;
        if (state.health > 0) {
          state.health -= 1;
        }
      }
    },
    resetGame: (state) => {
      state.health = 5;
      state.score = 0;
      state.slots = [];
      state.timeFinished = false;
    },
    setTimeFinished: (state, action) => {
      state.timeFinished = action.payload;
    },
  },
});

export const {
  displayRandomItem,
  setItems,
  submitCode,
  resetGame,
  setTimeFinished,
} = appSlice.actions;

export default appSlice.reducer;
